import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

class VisitasService {

    listaVisitas() {
        return axios.get(API + "/visitas")
    }

    pesquisarVisitas(crianca, vinculo, exibirTodosTiposSituacoes, servico, dataInicial, dataFinal) {
        return axios.get(API + "/visitas/find", {
            params: {
                nome: crianca !== "" ? crianca : undefined,
                idVinculo: vinculo !== "" ? vinculo : undefined,
                exibirTodosTiposSituacoes: exibirTodosTiposSituacoes !== "" ? exibirTodosTiposSituacoes : undefined,
                idSeac: servico !== "" ? servico : undefined,
                dataInicio: dataInicial !== "" ? dataInicial : undefined,
                dataFim: dataFinal !== "" ? dataFinal : undefined,
            }
        });
    }

    getCrianca(idCrianca) {
        return axios.get(API + `/criancas/${idCrianca}`)
    }

    visualizarVisitaCrianca(idCrianca) {
        return axios.get(API + `/criancas/${idCrianca}/visita`)
    }

    getVisita(idVisita) {
        return axios.get(API + `/visitas/${idVisita}`)
    }

    relacionamentosVisita(idCrianca, dataVisita, idSeac) {
        return axios.get(API + `/criancas/${idCrianca}/visita/relacionamentos-vinculos?dataVisita=${dataVisita}${idSeac ? `&idSeac=${idSeac}` : ""}`)
    }

    postVisitas(idCrianca, visitaRequestDTO) {
        return axios.post(API + `/criancas/${idCrianca}/visita`, visitaRequestDTO)
    }

    putVisitas(idVisita, visitaRequestDTO) {
        return axios.put(API + `/visitas/${idVisita}`, visitaRequestDTO)
    }

    deleteVisitas(idVisita) {
        return axios.post(API + `/visitas/${idVisita}/inativar`)
    }
}

const instanceVisitas = new VisitasService();
export default instanceVisitas;